// Ajout au panier sans quitter la page : tout formulaire produit qui n'est pas géré par <product-form>
// (sections perso comme pdp-ceinture, pdp-alarme) ajoute en AJAX puis ouvre le panier latéral du thème.
import { CartUpdatedEvent } from '@theme/events';

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !/\/cart\/add\/?$/.test(form.getAttribute('action') || '')) return;
  if (event.defaultPrevented || form.closest('product-form')) return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return; // pas de panier latéral : comportement normal (page panier)

  event.preventDefault();
  const buttons = document.querySelectorAll(`button[type="submit"][form="${form.id}"], #${CSS.escape(form.id || 'x')} button[type="submit"]`);
  buttons.forEach((b) => { b.disabled = true; b.classList.add('is-loading'); });

  const data = new FormData(form);
  data.append('sections', drawer.dataset.sectionId);
  data.append('sections_url', window.location.pathname);

  try {
    const res = await fetch(Theme.routes.cart_add_url, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'Ajout impossible');
    const cart = await (await fetch('/cart.js')).json();
    document.dispatchEvent(new CartUpdatedEvent({}, { itemCount: cart.item_count, source: 'trucsy-ajax-cart', sections: json.sections }));
    drawer.open();
  } catch (e) {
    document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: e.message } }));
  } finally {
    buttons.forEach((b) => { b.disabled = false; b.classList.remove('is-loading'); });
  }
});
